import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Typography, Button } from '@mui/material';
import { CheckCircle, ErrorOutline } from '@mui/icons-material';
import { useVerifyEmailQuery } from '../../store/api/authApi';

export const VerifyEmailPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') ?? '';

  const { data, error, isLoading } = useVerifyEmailQuery(token, { skip: !token });

  useEffect(() => {
    if (!data?.access_token) return;
    const t = setTimeout(() => {
      navigate(`/auth/callback?token=${data.access_token}&verified=1`, { replace: true });
    }, 1000);
    return () => clearTimeout(t);
  }, [data, navigate]);

  if (!token) {
    navigate('/auth/login', { replace: true });
    return null;
  }

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
      {isLoading && (
        <>
          <CircularProgress />
          <Typography color="text.secondary">Verifying your email…</Typography>
        </>
      )}
      {data && (
        <>
          <CheckCircle sx={{ fontSize: 52, color: 'success.main' }} />
          <Typography variant="h6" fontWeight={700}>Email verified!</Typography>
          <Typography color="text.secondary">Taking you to your account…</Typography>
        </>
      )}
      {error && (
        <>
          <ErrorOutline sx={{ fontSize: 52, color: 'warning.main' }} />
          <Typography variant="h6" fontWeight={700}>Link already used</Typography>
          <Typography color="text.secondary" sx={{ maxWidth: 360, textAlign: 'center' }}>
            {(error as any)?.data?.detail ?? 'This link has already been used. Please log in.'}
          </Typography>
          <Button variant="contained" onClick={() => navigate('/auth/login')}>
            Go to login
          </Button>
        </>
      )}
    </Box>
  );
};
